import * as React from "react";
import { SVGProps } from "react";
export const CloudIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5 16C3.88867 16 2.94433 15.611 2.167 14.833C1.389 14.0557 1 13.1113 1 12C1 10.9447 1.361 10.0313 2.083 9.26C2.80567 8.48933 3.68767 8.06933 4.729 8C5.04833 6.81933 5.69067 5.85767 6.656 5.115C7.62133 4.37167 8.736 4 10 4C11.4307 4 12.6737 4.48267 13.729 5.448C14.7843 6.41333 15.3747 7.59733 15.5 9C16.472 9 17.2983 9.34033 17.979 10.021C18.6597 10.7017 19 11.528 19 12.5C19 13.472 18.6597 14.2983 17.979 14.979C17.2983 15.6597 16.472 16 15.5 16H5ZM5 14.5H15.5C16.0553 14.5 16.5277 14.3057 16.917 13.917C17.3057 13.5277 17.5 13.0553 17.5 12.5C17.5 11.9447 17.3057 11.4723 16.917 11.083C16.5277 10.6943 16.0553 10.5 15.5 10.5H14.125L14 9.146C13.9027 8.118 13.472 7.25333 12.708 6.552C11.944 5.85067 11.0413 5.5 10 5.5C9.11133 5.5 8.31267 5.76733 7.604 6.302C6.896 6.83667 6.424 7.54167 6.188 8.417L5.896 9.438L4.833 9.5C4.16633 9.54133 3.611 9.80167 3.167 10.281C2.72233 10.7603 2.5 11.3333 2.5 12C2.5 12.6947 2.743 13.285 3.229 13.771C3.715 14.257 4.30533 14.5 5 14.5Z"
            fill="currentColor"
        />
    </svg>
);
CloudIcon.displayName = "CloudIcon";
